import { AttachmentResponse, ATTACHMENT_ENTITY_TYPE } from '@/api/services/common/attachment/common-attachment.dto'
import { Nullable } from '@/shared/types/app.types'

export interface DownloadableAttachmentState {
    entityType: Nullable<ATTACHMENT_ENTITY_TYPE>,
    attachments: AttachmentResponse[],
    attachmentService: any
}
export const initialDownloadableAttachmentState =
    (): DownloadableAttachmentState => ({
        entityType: null,
        attachments: [],
        attachmentService: null
    })
